import React from 'react';
import BackButton from '../../components/back-button';
import H1 from '../../components/h1';
import geographicPage from '../../contentful/geographicPage.json';
import Accordion from '../../components/accordion';
import Markdown from '../../components/markdown';
import Button from '../../components/button';
import styles from './geographic.module.scss';
import safeGa from '../../modules/safeGa';

const chapterLink = geographicPage.geographicItems[0].chapterLink;
const linksUnderImages = [
  'https://www.greater.sydney/',
  'http://www.planning.nsw.gov.au/Plans-for-your-area/Regional-Plans',
];
const ImageContainer = (sidebarImage, i) => {
  return (
    <div className={styles.imageContainer} key={sidebarImage.filename}>
      <img
        className={styles.img}
        src={'/contentful/' + sidebarImage.filename}
        alt={sidebarImage.altText}
      />
      <Button isExternal link={linksUnderImages[i]}>
        Read more
      </Button>
    </div>
  );
};
class GeographicPage extends React.Component {
  constructor() {
    super();
    this.state = {
      imageLoaded: false,
    };
  }
  componentDidMount() {
    safeGa('set', 'page', '/geographic.html');
    safeGa('send', 'pageview');
  }

  renderAccordion() {
    if (!this.state.imageLoaded) return;
    const props = this.props;
    return (
      <Accordion
        displayChapterLink={false}
        items={geographicPage.geographicItems}
        activeId={props.location.hash.replace('#', '')}
      />
    );
  }

  render() {
    return (
      <div className={`theme-green`}>
        <BackButton />
        <div className={styles.headlineRow}>
          <H1>Geographic Infrastructure Directions</H1>
          <a
            className={styles.chapterLink}
            target="_blank"
            href={`${window.location.origin}/chapters/${chapterLink}`}
          >
            <span>View Full Chapter</span>{' '}
            <img alt="Right arrow" src={'/img/button-arrow-icon.svg'} />
          </a>
        </div>
        <div className={styles.row}>
          <div className={styles.markdown}>
            <Markdown content={geographicPage.initialText} />
          </div>
          <div className={`desktopOnly ${styles.desktopSidebar}`}>
            {geographicPage.sidebarImages.map(ImageContainer)}
          </div>
        </div>
        <div className={`desktopOnly`}>
          <img
            className={styles.bottomImg}
            src={'/contentful/' + geographicPage.bottomImage.filename}
            alt={geographicPage.bottomImage.altText}
            onLoad={() => this.setState({ imageLoaded: true })}
          />
        </div>

        {this.renderAccordion()}
        <div className={`mobileOnly`}>
          {geographicPage.sidebarImages.map(ImageContainer)}
        </div>
      </div>
    );
  }
}
export default GeographicPage;



// WEBPACK FOOTER //
// ./src/pages/geographic/geographic.js